import React from "react";
import { FormGroup } from "react-bootstrap-3";
import styled from "styled-components";

const LabelStyled = styled.label`
  margin-right: 20px;
`;

function RadioButtonGroup({ value, onChange, field }) {
  const { fieldName, options, disabled } = field;

  return (
    <div>
      <FormGroup>
        <div className="radio c-radio needsclick">
          {options.map(option => {
            return (
              <LabelStyled className="needsclick">
                <input
                  disabled={disabled}
                  type="radio"
                  name={fieldName}
                  value={option.ticker}
                  checked={value === option.ticker}
                  className="needsclick"
                  onChange={event => onChange({ event, field: fieldName })}
                />

                <em className="fa fa-check" />

                {option.name}
              </LabelStyled>
            );
          })}
        </div>
      </FormGroup>
    </div>
  );
}

export default RadioButtonGroup;
